import React, { useState, useEffect } from 'react';

const UltimateNavbar = () => {
 const [scrolled, setScrolled] = useState(false);
 const [menuOpen, setMenuOpen] = useState(false);

 useEffect(() => {
 const handleScroll = () => setScrolled(window.scrollY > 50);
 window.addEventListener('scroll', handleScroll);
 return () => window.removeEventListener('scroll', handleScroll);
 }, []);

 const scrollToForm = () => {
 setMenuOpen(false);
 const formSection = document.getElementById('contact-form-section');
 if (formSection) formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 const scrollTo = (id) => {
 setMenuOpen(false);
 const el = document.getElementById(id);
 if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
 };

 const navLinks = [
 { label: 'होम', id: 'hero-section' },
 { label: 'परिचय', id: 'about-section' },
 { label: 'समस्याएं', id: 'problems-section' },
 { label: 'सेवाएं', id: 'services-section' },
 { label: 'संपर्क', id: 'contact-form-section' },
 ];

 return (
 <nav className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${scrolled ? 'bg-[#050507]/95 backdrop-blur-md' : 'bg-transparent'}`} data-testid="navbar">
 <div className="container mx-auto px-4 py-3">
 <div className="flex items-center justify-between">
 
 {/* Logo - Purple & Gold */}
 <button onClick={() => scrollTo('hero-section')} className="flex items-center gap-2" data-testid="navbar-logo">
 <img src="/logo-mata.png" alt="माता मलीहा" className="h-12 w-auto" />
 </button>

 {/* Desktop Links */}
 <div className="hidden lg:flex items-center gap-6">
 {navLinks.map((link, i) => (
 <button
 key={i}
 onClick={() => scrollTo(link.id)}
 className="text-[#D8D2C6] hover:text-[#F3EDE2] font-medium transition-colors"
 >
 {link.label}
 </button>
 ))}
 
 <button
 onClick={scrollToForm}
 className="px-6 py-2.5 bg-gradient-to-r from-[#f5d77e] to-[#d4a84b] hover:from-[#f5d77e] hover:to-[#f5d77e] text-black font-bold rounded-full shadow-lg hover:shadow-amber-500/25 transition-all hover:scale-105"
 data-testid="navbar-cta"
 >
 परामर्श लें
 </button>
 </div>

 {/* Mobile Menu Button */}
 <button
 onClick={() => setMenuOpen(!menuOpen)}
 className="lg:hidden p-2 rounded-lg text-[#D8D2C6] hover:text-[#F3EDE2]"
 data-testid="navbar-mobile-toggle"
 >
 <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
 {menuOpen ? (
 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
 ) : (
 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
 )}
 </svg>
 </button>
 </div>

 {/* Mobile Menu */}
 {menuOpen && (
 <div className="lg:hidden mt-4 py-4 border-t border-[#d4a84b]/20 bg-[#0B0B0E] rounded-xl">
 {navLinks.map((link, i) => (
 <button
 key={i}
 onClick={() => scrollTo(link.id)}
 className="block w-full text-left px-4 py-3 text-[#D8D2C6] hover:text-[#F3EDE2] hover:bg-[#17171C] font-medium transition-colors"
 >
 {link.label}
 </button>
 ))}
 <div className="px-4 pt-4">
 <button
 onClick={scrollToForm}
 className="w-full px-6 py-3 bg-gradient-to-r from-[#f5d77e] to-[#d4a84b] text-black font-bold rounded-full shadow-lg"
 >
 परामर्श लें
 </button>
 </div>
 </div>
 )}
 </div>
 </nav>
 );
};

export default UltimateNavbar;
